import currencyData from '../constants/currencyData';

export default function getCurrencySymbol(currencyCode: string): string {
  if (typeof currencyCode !== 'string') {
    return '€';
  }

  return currencyData[currencyCode?.toUpperCase()]?.symbol || '€';
}
